import DetailsToolbar from "./DetailsToolbar";

export default DetailsToolbar;
